import { createApp } from 'vue'
import { createPinia } from 'pinia'
import Bugsnag from '@bugsnag/js'
import BugsnagPluginVue from '@bugsnag/plugin-vue'
import BugsnagPerformance from '@bugsnag/browser-performance'
import Toast from 'vue-toastification'
import "vue-toastification/dist/index.css";

import App from './App.vue'
import router from './router'
import './assets/main.css'

const bugsnagApiKey = import.meta.env.VITE_BUGSNAG_API_KEY

Bugsnag.start({
    apiKey: bugsnagApiKey,
    plugins: [new BugsnagPluginVue()]
})
BugsnagPerformance.start({ apiKey: bugsnagApiKey })

const bugsnagVue = Bugsnag.getPlugin('vue')!

const app = createApp(App)

app.use(createPinia())
app.use(router)
app.use(bugsnagVue)
app.use(Toast, {
    position: "top-right",
    timeout: 5000,
    closeOnClick: true,
    pauseOnHover: true,
    draggable: true,
    draggablePercent: 0.6,
    showCloseButtonOnHover: false,
    hideProgressBar: true,
    closeButton: "button",
    icon: true,
    rtl: false
})

app.mount('#app')
